// Astrocartografia, shared helper functions

export const scoreColor = (score: number): string => {
  if (score >= 85) return 'text-[var(--color-success)]';
  if (score >= 70) return 'text-[var(--petrol)]';
  if (score >= 55) return 'text-[var(--color-warning)]';
  return 'text-[var(--color-error)]';
};

export const scoreEmoji = (score: number): string => {
  if (score >= 85) return '✦✦✦';
  if (score >= 70) return '✦✦';
  if (score >= 55) return '✦';
  return '○';
};

export const verdictColor = (verdict: string): string => {
  const map: Record<string, string> = {
    'Excelente':    'text-[var(--color-success)]',
    'Boa':          'text-[var(--petrol)]',
    'Neutra':       'text-[var(--text-tertiary)]',
    'Desafiadora':  'text-[var(--color-error)]',
  };
  return map[verdict] ?? 'text-[var(--text-secondary)]';
};

export const verdictEmoji = (verdict: string): string => {
  const map: Record<string, string> = {
    'Excelente':   '🌟',
    'Boa':         '✦',
    'Neutra':      '○',
    'Desafiadora': '⚠',
  };
  return map[verdict] ?? '○';
};

export const scoreBgColor = (score: number): string => {
  if (score >= 85) return '#22c55e';
  if (score >= 70) return '#C4A951';
  if (score >= 55) return '#f59e0b';
  return '#ef4444';
};

export function shareAtlasCountry(
  country: { flag_emoji?: string; country_name_pt?: string; overall_score?: number; love_score?: number; career_score?: number; life_quality_score?: number; verdict?: string },
  _userName?: string,
) {
  const flag    = country.flag_emoji ?? '🌐';
  const name    = country.country_name_pt ?? 'País';
  const score   = country.overall_score ?? 0;
  const love    = country.love_score ?? 0;
  const career  = country.career_score ?? 0;
  const life    = country.life_quality_score ?? 0;
  const verdict = verdictEmoji(country.verdict ?? 'Boa');

  const text = encodeURIComponent(
    `🌍 Descobri meu lugar no mundo com o Astrocartografia! ✦\n\n` +
    `${flag} ${name} é ${verdict} para mim, ${score}/100 de compatibilidade astrológica.\n\n` +
    `Amor: ${love} · Carreira: ${career} · Qualidade de vida: ${life}\n\n` +
    `Descubra os melhores países para o seu mapa natal:\n` +
    `https://professya.com/astrocartografia?utm_source=whatsapp`,
  );
  window.open(`https://wa.me/?text=${text}`, '_blank', 'noopener,noreferrer');
}

export function shareAtlasCustomCity(analysis: {
  city_confirmed?: string; country?: string; flag?: string;
  overall_score?: number; verdict?: string; verdict_subtitle?: string;
}) {
  const city    = analysis.city_confirmed ?? 'Cidade';
  const country = analysis.country ?? '';
  const flag    = analysis.flag ?? '🌐';
  const score   = analysis.overall_score ?? 0;
  const verdict = verdictEmoji(analysis.verdict ?? 'Boa');

  const text = encodeURIComponent(
    `🌍 Analisei ${city}, ${country} com o Astrocartografia!\n\n` +
    `${flag} ${verdict} ${score}/100 de compatibilidade astrológica.\n\n` +
    `Descubra qual cidade é perfeita para o seu mapa natal:\n` +
    `https://professya.com/astrocartografia?utm_source=whatsapp`,
  );
  window.open(`https://wa.me/?text=${text}`, '_blank', 'noopener,noreferrer');
}
